module.exports = __webpack_public_path__ + "img/for the people.87f12111.png";